import { plural } from '@cian/utils';
import { VILLAGE_VARIANTS } from '../interfaces/villages';

export const createVillagesString = (totalItems: number) => {
  return `${totalItems} ${plural(totalItems, VILLAGE_VARIANTS)}`;
};
